import { useMemo } from 'react';
import { EmptyState } from '@carboledger/ui';
import { SummaryTiles } from '@/components/common';
import { useTranslations } from '@/hooks';
import { buildTransactionFilters } from '@/lib/mappers';
import { TransactionsTable } from '@/slices/transactions';
import emptyBoxIllustration from '@/assets/illustrations/empty-box.png';
import { buildTabEmptyState, buildTabNoResults } from '../constants/inventoryEmptyStates';

/**
 * Props:
 *   module           the active module route segment
 *   certificateType  the module's `CertificateType`
 *   item             the inventory row's facility, material and terminal NAME
 */
export const InventoryTransactionsTabView = ({ module, certificateType, item }) => {
  const t = useTranslations();
  // The ledger is written by other flows, so this tab offers no Add.
  const emptyState = useMemo(
    () =>
      buildTabEmptyState(t, {
        titleKey: 'TRANSACTIONS_EMPTY_TITLE',
        descriptionKey: 'TRANSACTIONS_EMPTY_DESCRIPTION',
      }),
    [t],
  );
  const noResults = useMemo(() => buildTabNoResults(t, 'TRANSACTIONS_NO_RESULTS_TITLE'), [t]);

  // `TransactionFilters` has no storage or B2B key, so only a site can be narrowed to.
  const transactionFilters = useMemo(() => buildTransactionFilters(item), [item]);

  if (!transactionFilters) {
    return (
      <SummaryTiles>
        <EmptyState
          image={<img src={emptyBoxIllustration} alt="" width={200} height={200} />}
          title={t('INVENTORY_UNAVAILABLE_TITLE')}
          description={t('INVENTORY_UNAVAILABLE_DESCRIPTION')}
        />
      </SummaryTiles>
    );
  }

  return (
    <SummaryTiles>
      <TransactionsTable
        module={module}
        certificateType={certificateType}
        extraFilters={transactionFilters}
        emptyState={emptyState}
        noResults={noResults}
      />
    </SummaryTiles>
  );
};
